import {
  FORM_INPUT_CLASS_NAME,
  FORM_TEXTAREA_CLASS_NAME,
} from "@/components/Forms/form-control-styles";
export { SELECT_CLASS_NAMES as ONBOARDING_SELECT_CLASS_NAMES } from "@/components/Selects/select-class-names";

export const ONBOARDING_FORM_STYLES = {
  header: "mb-7",
  eyebrow: "text-xs font-semibold uppercase tracking-widest text-primary",
  title: "mt-2 text-3xl font-semibold tracking-tight text-slate-900",
  description: "mt-3 max-w-xl text-sm leading-6 text-slate-500 sm:text-base",
  sectionHeading: "text-base font-semibold text-slate-900",
  body: "space-y-5",
  footer:
    "mt-6 flex flex-col gap-3 border-t border-slate-200 pt-5 sm:flex-row sm:items-center sm:justify-end",
  primaryButton:
    "h-12 w-full gap-2 rounded-xl px-7 text-sm font-semibold sm:w-auto sm:min-w-32",
  secondaryButton:
    "min-h-12 w-full gap-2 rounded-xl border-slate-200 px-5 text-sm font-semibold text-slate-600 hover:bg-slate-50 hover:text-slate-900 sm:w-auto",
  backButton:
    "mb-5 -ml-2 min-h-11 gap-2 rounded-xl px-2 text-sm text-slate-500 hover:bg-slate-50 hover:text-slate-900",
  error:
    "rounded-xl border border-red-200 bg-red-50 p-4 text-sm leading-6 text-red-700",
  textarea: FORM_TEXTAREA_CLASS_NAME,
  confirmation:
    "max-h-[85dvh] w-[calc(100vw-2rem)] overflow-y-auto rounded-2xl border-slate-200 bg-white p-6 sm:max-w-md sm:rounded-2xl",
  section: "rounded-2xl border border-slate-200 bg-white p-5 sm:p-6",
  label: "text-sm font-medium text-slate-700",
  input: FORM_INPUT_CLASS_NAME,
} as const;
